import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { GroupService } from '../../../providers/semantria-api/group.service';
import { ActionPlan, ActionPlanService } from '../../../providers/storage-api/actionplan.service';

@Injectable()
export class ActionPlanCacheService {
  private readonly _map: Map<string, ActionPlan>;

  private _loadingPromise: Promise<void>;
  get waitUntilLoaded(): Promise<void> {
    return this._loadingPromise;
  }

  private readonly _update = new Subject<ActionPlan>();
  private readonly _delete = new Subject<string>();
  private readonly _add = new Subject<ActionPlan>();
  private readonly _list = new BehaviorSubject<ActionPlan[]>([]);

  readonly update$ = this._update.asObservable();
  readonly delete$ = this._delete.asObservable();
  readonly add$ = this._add.asObservable();
  readonly list$ = this._list.asObservable();

  constructor(
    private actionPlanService: ActionPlanService,
    private groupService: GroupService
  ) {
    this._map = new Map<string, ActionPlan>();

    this.load();
  }

  get(id: string): ActionPlan {
    if (!this._map.has(id)) {
      throw new Error(`${id} Action Plan does not exist`);
    }

    return this._map.get(id);
  }

  getAll(): ActionPlan[] {
    return Array.from(this._map.values());
  }

  update(actionPlan: ActionPlan): void {
    this._map.set(actionPlan.plan_id, actionPlan);

    this._update.next(actionPlan);

    this.emitList();
  }

  delete(id: string): void {
    this._map.delete(id);

    this._delete.next(id);

    this.emitList();
  }

  add(actionPlan: ActionPlan): void {
    this._map.set(actionPlan.plan_id, actionPlan);

    this._add.next(actionPlan);

    this.emitList();
  }

  private load(): void {
    this._loadingPromise = this.actionPlanService
      .listActionPlans(this.groupService.getSelectedGroupId(), {
        page_size: 1000, // to get all
      })
      .then((r) => {
        r.data.forEach((a) => this._map.set(a.plan_id, a));

        this.emitList();
      });
  }

  private emitList(): void {
    this._list.next(this.getAll());
  }
}
